import React from 'react';

import { FontAwesome } from 'react-js-vector-icons';

export default class NavButton extends React.Component {
  render() {
    const link = this.props.target ? this.props.target : '#';

    return [
      <a href={ link } key="test" className="ms-textAlignCenter ms-fontColor-neutralPrimary" style={{ display: 'inline-block', margin: '0 15px', cursor: 'pointer', textDecoration: 'none' }}>
        <FontAwesome name={ this.props.iconName } color="#666" size={ this.props.iconSize } />
        <div>{ this.props.title }</div>
      </a>
    ]
  }
}


// WEBPACK FOOTER //
// ./src/component/navigation/NavButton.jsx